import React from 'react'

export default function ImageComponent(props) {
    return (
        <img {...props} />
    )
}
